module.exports = __webpack_public_path__ + "img/running-shoes.a761cc1f.png";